var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.15991 4.60547H0.234375V13.9348H3.15991V4.60547Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0774 4.4014C10.9695 4.38792 10.8549 4.38117 10.7403 4.37443C9.10228 4.30702 8.17879 5.27771 7.85523 5.69564C7.7676 5.81024 7.72715 5.87765 7.72715 5.87765V4.63059H4.92969V13.96H7.72715H7.85523C7.85523 13.0095 7.85523 12.0658 7.85523 11.1153C7.85523 10.603 7.85523 10.0907 7.85523 9.57839C7.85523 8.94474 7.80804 8.27066 8.12486 7.69094C8.3945 7.2056 8.87984 6.96293 9.42585 6.96293C11.0437 6.96293 11.0774 8.4257 11.0774 8.56051C11.0774 8.56726 11.0774 8.574 11.0774 8.574V14.0004H14.0029V7.91339C14.0029 5.83046 12.9446 4.60362 11.0774 4.4014Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6987 3.3974C2.63686 3.3974 3.3974 2.63687 3.3974 1.6987C3.3974 0.760534 2.63686 0 1.6987 0C0.76053 0 0 0.760534 0 1.6987C0 2.63687 0.76053 3.3974 1.6987 3.3974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.4fff2195a7146d029dbd7e3884537143.svg";
export { ForwardRef as ReactComponent };